export default __webpack_public_path__ + "static/media/news.97f15f14.png";